import socket from '@/plugins/socket'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    init: (state, datas) => { state.list = datas }
  },
  actions: {
    init (state) { socket.get('SportSportGamestatusdiscipline', 'Sport/GameStatusDiscipline/init') }
  },
  getters: {
    getOrders: (state) => (disciplineId, gameStatusId) => {
      let value = []
      if (gameStatusId !== 100) {
        const statuses = state.list.filter((item) => {
          return item.disciplineId === disciplineId && item.gameStatusId === gameStatusId && item.order !== null
        })
        value = (statuses.length > 0 ? statuses.map(item => item.order) : [])
      }
      return value
    },
    getStatuses: (state) => (disciplineId, order) => {
      let list = []
      if (order.length > 0) {
        order = order.map(item => item + 1)
        list = state.list.filter((item) => {
          return item.disciplineId === disciplineId && order.indexOf(item.order) !== -1
        }).map(item => item.gameStatusId)
      }

      return list
    },
    getStatusEnable: (state) => (disciplineId, gameStatusId) => {
      let value = true
      const list = state.list.filter((item) => {
        return item.disciplineId === disciplineId
      })
      if (list.length > 0) {
        value = list.filter((item) => {
          return item.gameStatusId === gameStatusId
        }).length > 0
      }

      return value
    }
  }
}
